import Swiper, { Navigation, Pagination } from 'swiper';
import SwiperCore from 'swiper';

export function lectorReviewSlider() {
  const $slider = $('.lector-review-slider');
  if (!$slider || !$slider.length) return;

  SwiperCore.use([Pagination, Navigation]);

  const swiper = new Swiper('.lector-review-slider', {
    pagination: {
      el: '.lector-review-slider-pagination',
      clickable: true,
      renderBullet: function (index, className) {
        return '<span class="' + className + '">' + (index + 1) + "</span>";
      },
    },
    navigation: {
      nextEl: '.lector-review-slider-next',
      prevEl: '.lector-review-slider-prev'
    },
    breakpoints: {
      0: {
        slidesPerView: 'auto',
        spaceBetween: 20,
        centeredSlides: true
      },
      768: {
        slidesPerView: 'auto',
        spaceBetween: 90,
        centeredSlides: true
      }
    }
  });
}
